import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { HerracContext } from "../../App";

function MotorcycleForm({ additionalAttributes, setAdditionalAttributes, subCategoryId }) {
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const { fuelTypeData } = useContext(HerracContext);

  // Debug logging
  useEffect(() => {
    console.log('🏍️ MotorcycleForm mounted with subCategoryId:', subCategoryId);
    console.log('📋 Current additionalAttributes:', additionalAttributes);
  }, [subCategoryId, additionalAttributes]);

  useEffect(() => {
    if (subCategoryId) {
      console.log('📦 Fetching brands for motorcycles...');
      axios.get(`https://api.herracim.az/api/Brand/BySubCategoryId?subCategoryId=${subCategoryId}`)
        .then(response => {
          console.log('✅ Brands loaded:', response.data.length, 'items');
          setFilteredBrands(response.data);
          setFilteredModels([]);
        })
        .catch(error => {
          console.error('❌ Error loading brands:', error);
          setFilteredBrands([]);
        });
    } else {
      setFilteredBrands([]);
      setFilteredModels([]);
    }
  }, [subCategoryId]);

  useEffect(() => {
    if (selectedBrand) {
      console.log('📦 Fetching models for brand:', selectedBrand);
      axios.get(`https://api.herracim.az/api/Model/ByBrandId?brandId=${selectedBrand}`)
        .then(response => {
          console.log('✅ Models loaded:', response.data.length, 'items');
          setFilteredModels(response.data);
        })
        .catch(error => {
          console.error('❌ Error loading models:', error);
          setFilteredModels([]);
        });
    } else {
      setFilteredModels([]);
    }
  }, [selectedBrand]);

  const handleBrandChange = (e) => {
    const brandId = e.target.value;
    console.log('🏷️ Brand selected:', brandId);
    
    setSelectedBrand(brandId);
    setAdditionalAttributes({
      ...additionalAttributes,
      brandId: brandId,
      modelId: ""
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`🔧 Field changed: ${name} = ${value}`);
    
    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: value,
    });
  };

  const currentYear = new Date().getFullYear();

  return (
    <div className="motorcycleForm">
      <div>
        <h3>
          Marka <span>*</span>
          <span className="tooltip-icon" title="Motosiklet istehsalçısı">ℹ️</span>
        </h3>
        <select 
          name="brandId" 
          onChange={handleBrandChange} 
          defaultValue=""
          disabled={filteredBrands.length === 0}
        >
          <option value="" disabled>
            {filteredBrands.length === 0 ? 'Yüklənir...' : 'Seçin'}
          </option>
          {filteredBrands.map((brand) => (
            <option key={brand.id} value={brand.id}>{brand.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          Model <span>*</span>
          <span className="tooltip-icon" title="Motosiklet modeli">ℹ️</span>
        </h3>
        <select 
          name="modelId" 
          onChange={handleChange} 
          defaultValue="" 
          disabled={filteredModels.length === 0}
        >
          <option value="" disabled>
            {selectedBrand ? (filteredModels.length === 0 ? 'Yüklənir...' : 'Seçin') : 'Əvvəlcə marka seçin'}
          </option>
          {filteredModels.map((model) => (
            <option key={model.id} value={model.id}>{model.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          İstehsal ili <span>*</span>
          <span className="tooltip-icon" title="Buraxılış ili">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="year" 
          min="1900" 
          max={currentYear} 
          placeholder={currentYear.toString()}
          required 
          onChange={handleChange} 
        />
      </div>

      <div>
        <h3>
          Yanacaq növü <span>*</span>
          <span className="tooltip-icon" title="Mühərrik yanacağı">ℹ️</span>
        </h3>
        <select name="fuelTypeId" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          {fuelTypeData.map((fuelType) => (
            <option key={fuelType.id} value={fuelType.id}>{fuelType.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          Mühərrik həcmi (CC) <span>*</span>
          <span className="tooltip-icon" title="Kubik santimetr">ℹ️</span>
        </h3>
        <select name="engineCapacity" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="50">50 CC (Scooter)</option>
          <option value="125">125 CC</option>
          <option value="150">150 CC</option>
          <option value="200">200 CC</option>
          <option value="250">250 CC</option>
          <option value="400">400 CC</option>
          <option value="600">600 CC</option>
          <option value="750">750 CC</option>
          <option value="1000">1000 CC</option>
          <option value="1200">1200 CC+</option>
        </select>
      </div>

      <div>
        <h3>
          Yürüş (km) <span>*</span>
          <span className="tooltip-icon" title="Ümumi yürüş">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="mileage" 
          min={0} 
          placeholder="15000"
          required 
          onChange={handleChange} 
        />
      </div>

      <div>
        <h3>
          Sürətlər qutusu <span>*</span>
          <span className="tooltip-icon" title="Transmissiya tipi">ℹ️</span>
        </h3>
        <select name="transmission" required onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="Mexanik">Mexanik (Manual)</option>
          <option value="Avtomat">Avtomat (Automatic)</option>
          <option value="Yarımavtomat">Yarımavtomat (Semi-auto)</option>
        </select>
      </div>

      <div>
        <h3>
          Mühərrik gücü (a.g.) <span>*</span>
          <span className="tooltip-icon" title="At gücü (HP)">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="enginePower" 
          placeholder="50"
          min="5"
          max="300"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Ban növü <span>*</span>
          <span className="tooltip-icon" title="Motosiklet tipi">ℹ️</span>
        </h3>
        <select name="bodyType" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Sport">Sport</option>
          <option value="Cruiser">Cruiser</option>
          <option value="Touring">Touring</option>
          <option value="Naked">Naked / Street</option>
          <option value="Adventure">Adventure</option>
          <option value="Scooter">Scooter</option>
          <option value="Chopper">Chopper</option>
          <option value="Enduro">Enduro / Off-road</option>
        </select>
      </div>

      <div>
        <h3>
          Rəng <span>*</span>
          <span className="tooltip-icon" title="Kuzov rəngi">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="color" 
          placeholder="Qara, Qırmızı, Mavi..."
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Oturacaq sayı <span>*</span>
          <span className="tooltip-icon" title="Neçə nəfərlik">ℹ️</span>
        </h3>
        <select name="seatCount" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="1">1 nəfərlik (Solo)</option>
          <option value="2">2 nəfərlik</option>
          <option value="3">3 nəfərlik</option>
        </select>
      </div>

      <div>
        <h3>
          Yeni? <span>*</span>
          <span className="tooltip-icon" title="0 km yenidirmi?">ℹ️</span>
        </h3>
        <select name="isNew" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli (0 km)</option>
          <option value="false">Xeyr (İşlənmiş)</option>
        </select>
      </div>

      <div>
        <h3>
          Sahiblərin sayı <span>*</span>
          <span className="tooltip-icon" title="Neçənci sahibdir?">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="ownerCount" 
          min={0} 
          max={10}
          placeholder="1"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Texniki baxışdan keçib? <span>*</span>
          <span className="tooltip-icon" title="Technical inspection">ℹ️</span>
        </h3>
        <select name="hasTechnicalInspection" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Sığorta var? <span>*</span>
          <span className="tooltip-icon" title="Insurance">ℹ️</span>
        </h3>
        <select name="hasInsurance" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Qəzalı olub? <span>*</span>
          <span className="tooltip-icon" title="Qəza keçirib?">ℹ️</span>
        </h3>
        <select name="isAccidented" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ⚠️</option>
          <option value="false">Xeyr ✅</option>
        </select>
      </div>

      <div>
        <h3>
          VIN nömrəsi <span>*</span>
          <span className="tooltip-icon" title="17 simvollu unikal kod">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="vin" 
          placeholder="1HGBH41JXMN109186"
          maxLength={17}
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Bazar (istehsal ölkəsi) <span>*</span>
          <span className="tooltip-icon" title="Hansı bazar üçün istehsal olunub">ℹ️</span>
        </h3>
        <select name="marketCountry" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Yaponiya">Yaponiya</option>
          <option value="Avropa">Avropa</option>
          <option value="Amerika">Amerika (ABŞ)</option>
          <option value="Çin">Çin</option>
          <option value="Hindistan">Hindistan</option>
          <option value="Türkiyə">Türkiyə</option>
          <option value="Digər">Digər</option>
        </select>
      </div>
    </div>
  );
}

export default MotorcycleForm;